import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { toast } from "sonner";
import { authApi, apiError, COACH_PROGRAMS } from "../lib/api";
import { subscribeToPush } from "../lib/push";
import { useLang } from "../i18n/LanguageContext";
import { fmt } from "../i18n/uiText";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

export default function Login() {
  const navigate = useNavigate();
  const { u } = useLang();
  const L = u.login;
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    try {
      const data = await authApi.login(email, password);
      toast.success(fmt(L.toastWelcome, { name: data.user.nombre }));
      if (data.user.role === "user" || data.user.role === "invitado" || data.user.role === "inversor" || data.user.role === "docente") subscribeToPush();
      const dest = data.user.requires_onboarding ? "/capacitaciones"
        : data.user.role === "admin" ? "/admin/dashboard"
        : data.user.role === "staff" ? "/admin/chat"
        : data.user.role === "instructor" ? "/instructor"
        : data.user.role === "invitado" ? "/invitados"
        : data.user.role === "inversor" ? "/inversores"
        : data.user.role === "docente" ? "/docentes"
        : COACH_PROGRAMS.includes(data.user.programa) ? "/coach" : "/mi-cuenta";
      setTimeout(() => navigate(dest), 1000);
    } catch (err) {
      toast.error(apiError(err, L.toastError));
    }
  };

  return (
    <div className="min-h-screen bg-navy flex flex-col">
      <div className="max-w-md w-full mx-auto px-6 flex-1 flex flex-col justify-center py-16">
        <button onClick={() => navigate("/")} className="flex items-center gap-1.5 text-white/70 hover:text-white text-sm font-semibold transition-colors mb-10">
          <ArrowLeft className="w-4 h-4" /> {L.back}
        </button>

        <img src="/logo-supera-light.png" alt="Supera Leadership" className="h-14 w-auto object-contain self-start mb-8" />

        <p className="text-xs font-extrabold tracking-[0.25em] text-gold">{L.welcome}</p>
        <h1 className="mt-2 text-4xl font-extrabold text-white">
          {L.titlePre} <span className="font-serif-it text-gold">{L.titleAccent}</span>
        </h1>

        <form onSubmit={submit} className="mt-8 bg-white rounded-[28px] p-8 shadow-2xl">
          <Label className="text-sm font-bold text-[#0A1C30] mb-1.5 block">{L.email}</Label>
          <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="tucorreo@ejemplo.com" />
          <Label className="text-sm font-bold text-[#0A1C30] mb-1.5 block mt-5">{L.password}</Label>
          <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" />
          <button type="submit" className="mt-7 w-full flex items-center justify-center gap-2 rounded-2xl bg-[var(--gold)] hover:bg-[var(--gold-soft)] text-[#0A1C30] font-extrabold text-lg py-4 transition-colors">
            {L.enter} <ArrowRight className="w-5 h-5" />
          </button>
        </form>

        <p className="text-center mt-6 text-white/70 text-sm">
          {L.noAccount}{" "}
          <button onClick={() => navigate("/")} className="font-bold text-gold hover:underline underline-offset-4">{L.startHere}</button>
        </p>
      </div>
    </div>
  );
}
